import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef, useRef } from 'react';
import classNames from 'classnames';
import '../mergeRefs/78d5bc4c67d8d58f9c10e9410225355915c50badf967bc3a0d22a094587a8377.cfe-internal.js';
import '../../components/629495c61f6f3ffdfe2248a13b452d018cea8d55bb88c94e497bf6f5395fc2fd.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useIsTruncated from '../../hooks/useIsTruncated/da191d8e34dc774b30780feedb25df2deae1330988b257de2496213521194b9d.cfe-internal.js';
import Tooltip from '../../components/Tooltip/303de8f785b9987afea88aa6b28176d2cc278b105d33ed5d93d1cf139ee9589d.cfe-internal.js';
import mergeRefs from '../mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["children", "lightTheme", "delayMs", "className", "asChild"];
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    lightTheme = _ref.lightTheme,
    _ref$delayMs = _ref.delayMs,
    delayMs = _ref$delayMs === void 0 ? 500 : _ref$delayMs,
    className = _ref.className,
    _ref$asChild = _ref.asChild,
    asChild = _ref$asChild === void 0 ? false : _ref$asChild,
    rest = _objectWithoutProperties(_ref, _excluded);
  var internalRef = useRef(null);
  var isTruncated = useIsTruncated(internalRef);
  var willClone = asChild && /*#__PURE__*/React__default.isValidElement(children) && typeof children !== 'string' && typeof children !== 'number';
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    content: willClone ? children.props.children : children,
    disabled: !isTruncated,
    lightTheme: lightTheme,
    delayMs: delayMs,
    "aria-hidden": true
  }, willClone ? ( /*#__PURE__*/React__default.cloneElement(children, {
    className: classNames(className, children.props.className),
    ref: mergeRefs(children.ref, ref, internalRef)
  })) : /*#__PURE__*/React__default.createElement("div", _extends({
    className: className,
    ref: mergeRefs(ref, internalRef)
  }, rest), children));
});
var Text$1 = Text;

export { Text$1 as default };
